// Batch 0 (UX/IA overhaul) — pure builder for the device-context breadcrumb.
//
// Split out from <DeviceContextLabel> so the segment logic is unit-tested
// without rendering. Produces the ordered ["Site", "NVR (make model)", "Ch N"]
// segments, omitting any segment whose data is absent, so it works with
// today's partial payload and gets richer as Batch 1 fills in site_name /
// source_id.
import type { CameraRef } from "@/types/deviceRef";

/** Build the "NVR" segment from make/model — e.g. "Hikvision DS-7616" or, if
 *  only one is known, just that one; null if neither is present. */
function nvrSegment(cam: CameraRef): string | null {
  const parts = [cam.nvr_make, cam.nvr_model]
    .map((s) => (s ?? "").trim())
    .filter(Boolean);
  if (parts.length === 0) return null;
  return parts.join(" ");
}

export function buildDeviceContext(
  cam: CameraRef,
  variant: "full" | "compact" = "full",
): string[] {
  const segments: string[] = [];

  if (variant === "full") {
    const site = (cam.site_name ?? "").trim();
    if (site) segments.push(site);
  }

  const nvr = nvrSegment(cam);
  if (nvr) segments.push(nvr);

  if (typeof cam.channel_no === "number" && cam.channel_no > 0) {
    segments.push(`Ch ${cam.channel_no}`);
  }

  return segments;
}
